import { render } from "./ChainedDialogComponent.vue?vue&type=template&id=3bc52fa0&scoped=true"
import script from "./ChainedDialogComponent.vue?vue&type=script&lang=js"
export * from "./ChainedDialogComponent.vue?vue&type=script&lang=js"

import "./ChainedDialogComponent.vue?vue&type=style&index=0&id=3bc52fa0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc52fa0"]])

export default __exports__